import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';
const badgeVariants = cva('inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium border transition-colors', {
  variants: {
    variant: {
      default: 'bg-neutral-100 text-neutral-700 border-neutral-200',
      primary: 'bg-atios-light text-atios-dark border-atios-primary/20',
      success: 'bg-success-light text-success-dark border-success/20',
      warning: 'bg-warning-light text-warning-dark border-warning/20',
      error: 'bg-error-light text-error-dark border-error/20',
      outline: 'bg-white text-neutral-600 border-neutral-300'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}
function Badge({
  className,
  variant,
  ...props
}: BadgeProps) {
  return <div className={cn(badgeVariants({
    variant
  }), className)} {...props} data-id="element-332" />;
}
export { Badge, badgeVariants };